import store from "../store";
import Alert from "../models/Alert";
import {
  addErrorAlert,
  removeErrorAlert,
  addSuccessAlert,
  removeSuccessAlert,
  addMessageAlert,
  removeMessageAlert,
  addWarningAlert,
  removeWarningAlert
} from "../actions/AlertActions";

class AlertService {
  addErrorAlert(message) {
    const alert = new Alert(message, false);
    store.dispatch(addErrorAlert(alert));
  }

  removeErrorAlert(id) {
    store.dispatch(removeErrorAlert(id));
  }

  addSuccessAlert(message) {
    const alert = new Alert(message, false);
    store.dispatch(addSuccessAlert(alert));
  }

  removeSuccessAlert(id) {
    store.dispatch(removeSuccessAlert(id));
  }

  addMessageAlert(message) {
    const alert = new Alert(message, true);
    store.dispatch(addMessageAlert(alert));
  }

  removeMessageAlert(id) {
    store.dispatch(removeMessageAlert(id));
  }

  addWarningAlert(message) {
    const alert = new Alert(message, true);
    store.dispatch(addWarningAlert(alert));
  }

  removeWarningAlert(id) {
    store.dispatch(removeWarningAlert(id));
  }
}

let instance = new AlertService();
export default instance;
